<template>
  <v-layout>
    <vue-element-loading :active="true" />
  </v-layout>
</template>


<script>
import VLayout from "@/layouts/Default";
import { getApiUri } from "@/lib/api-config.js";

export default {
  components: {
    VLayout,
  },
  props: {
    code: String,
  },
  computed: {
    provider () {
      return this.$route.params.provider;
    },
  },
  mounted: function () {
    const ALLOWED_PROVIDERS = {
      facebook: true,
      instagram: false,
      twitter: true,
    };

    if (this.$route.meta.done) {
      this.doLogin();
      return;
    }

    if (this.$route.meta.error) {
      this.$router.push({ name: "login-error", query: { code: "social-" + this.code } });
      return;
    }

    try {
      if (!ALLOWED_PROVIDERS[this.provider]) {
        this.$router.push({ name: "login" });
        return;
      }

      const apiUrl = getApiUri();
      const frontend = process.env.VUE_APP_AUTHX_SOCIAL_FRONT_REDIRECT_KEY;
      const authUrl = `${apiUrl}/authx/vooyguest/1/auth/social/${this.provider}/to/${frontend}/`;
      window.location = authUrl;
    }
    catch(e) {
      this.$sentry({ capture: e });
      this.$router.push({ name: "login" });
    }
  },
  methods: {
    doLogin () {
      const access = this.$route.query.access;
      const refresh = this.$route.query.refresh;
      this.$store.dispatch("auth/RAW_LOGIN", { access, refresh }).then(
        () => {
          this.$store.dispatch("naturalperson/GET_MAIN_PATIENT", {}).then(
            response => {
              // Si el usuario no tiene pacientes le redirigimos para que cree uno
              if (response.data.uuid) {
                this.$router.push({
                  name: "userhome",
                  params: { pt_uuid: response.data.uuid },
                });
              } else {
                this.$router.push({
                  name: "patientdata",
                });
              }
            },
            err => {
              this.mnotify_error({
                text: this.$t("organization_list.error.retrieving_mine"),
                debug: err,
              });
            }
          );
        },
        err => {
          this.$sentry({ capture: err });
          this.$router.push({ name: "fallback-error-page" });
        }
      );
    },
  },
};
</script>
